import { render } from "./lifeService.vue?vue&type=template&id=1bc9bd53&scoped=true"
import script from "./lifeService.vue?vue&type=script&lang=js"
export * from "./lifeService.vue?vue&type=script&lang=js"

import "./lifeService.vue?vue&type=style&index=0&id=1bc9bd53&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc9bd53"]])

export default __exports__